/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * The module that contains AJS metrics factories.
 * @preferred
 * @module MetricsModule
 */

import angular from 'angular';

import { initAjsDependency } from 'ajs/js/utilities/ajsDependency';

import { Series, SERIES_TOKEN } from './factories/series.factory';

const ajsMetricsModule = angular.module('avi/metrics');

const factories = [
    {
        itemClass: Series,
        name: SERIES_TOKEN,
    },
];

factories.forEach(({ name, itemClass }) => {
    initAjsDependency(ajsMetricsModule, 'factory', name, itemClass);
});
